import { useLocation } from 'react-router-dom';
import { useState, useEffect } from "react";
import cargandoCard from '../../../components/cargando-card';

export default function MascotaRefugio() {
    const location = useLocation();
    const [cargandoPage, setCargandoPage] = useState(true);
    // const queryParams = new URLSearchParams(location.search); // Parse the query string
    // const id = queryParams.get('id'); // Get the "id" parameter
    // const name = queryParams.get('name'); // Get the "name" parameter

    // console.log('ID:', id); // "123"
    // console.log('Name:', name); // "Fido"

    // useEffect(() => {
    // iniciar();
    // const params = new URLSearchParams(location.search); // Create URLSearchParams instance to parse query string
    // const someParam = params.get('someParam'); // Example of getting a parameter by name
    // console.log("Parameter from URL:", someParam);
    // }, [location]);

    useEffect(() => {
        console.log('MascotaRefugio useEffect');
        iniciar();
    }, []);

    const iniciar = async () => {
        try {

            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const render = () => {
        if (cargandoPage === true) {
            return cargandoCard();
        }
        return (
            <div>
                <h1>Mascota Details</h1>
                {/* <p>ID: {id}</p> */}
                {/* <p>Name: {name}</p> */}
            </div>
        );
    };

    return render();
}
